export var TICK_LENGTH = 8;
export var TICK_MARGIN = 4;
export var TICK_LINE_HEIGHT = 16;
export var X_TICK_COUNT_RATIO = 100;
export var Y_TICK_COUNT_RATIO = 50;
